<template>
  <v-menu
    bottom
    offset-y
    left>
    <v-btn
      slot="activator"
      flat
      small
      icon>
      <v-icon>mdi-settings</v-icon>
    </v-btn>
    <v-card class="settings-card">
      <div class="settings-options pt-2 pb-2">
        <v-flex
          v-for="(setting, index) in settings"
          :key="index"
          xs4 class="settings-option"
          @click="gotoRouterName(setting.route)">

          <v-icon>{{ setting.icon }}</v-icon>
          <span class="mt-1 setting-title text-xs-center">{{setting.title}}</span>
        </v-flex>

      </div>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'SettingsMenu',
  data() {
    return {
      settings: [
        { title: 'Requerimentos', icon: 'mdi-format-list-bulleted', route: 'ApplicationList' },
        { title: 'Tipologias', icon: 'mdi-format-list-bulleted-type', route: 'TypologyList' },
        { title: 'Clientes', icon: 'mdi-account-group-outline', route: 'CustomersList' },
        { title: 'Funcionários', icon: 'mdi-account-group-outline', route: 'AdminsList' },
        { title: 'Atualizar Requerente', icon: 'mdi-account-edit-outline', route: 'UpdateEntity' },
        { title: 'Tipos de Requerimento', icon: 'mdi-file-send', route: 'ApplicationTypesList' },
        { title: 'Tipos de Documento', icon: 'mdi-file-document-box-multiple-outline', route: 'DocumentTypesList' },
        { title: 'Tipos de Estudo Ambiental', icon: 'mdi-settings', route: 'EnviromentalStudyTypeList' },
      ],
    };
  },
  methods: {
    gotoRouterName(name) {
      this.$router.push({ name });
    },
  },
};
</script>

<style lang="scss">
  h3 {
    margin-bottom: 15px;
  }

  .settings-card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 310px;
  }

  .settings-options {
    display: flex;
    flex-wrap: wrap;
  }

  .settings-option {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding: 8px !important;
  }

  .setting-title {
    font-size: 10px;
  }
</style>
